import LocationAdapter from 'shared/location_adapter';
import AhoyTracker from 'shared/ahoy_tracker';
import $ from "jquery"

let heartbeatInterval = '';
export default class WatchSessionLimiter {
  static get interval() {
    return (Number(window.watchSessionLimiterInterval) || 60) * 1000;
  }

  static startHeartbeat(id, playableType) {
    WatchSessionLimiter.heartbeat(id, playableType);

    heartbeatInterval = setInterval(function () {
      WatchSessionLimiter.heartbeat(id, playableType);
    }, WatchSessionLimiter.interval);
  }

  static heartbeat(id, playableType) {
    const headers = window.watchHe != undefined ? { 'X-Watch-He' : window.watchHe } : {}

    let endpoint = "videos";
    if(playableType == "livestreamings") {
      endpoint = "live";
    }

    $.ajax({
      url: "/"+endpoint+"/"+id+"/post_stream",
      dataType: "json",
      method: "POST",
      error: this.onError,
      headers: headers
    });
  }

  static onError(xhr) {
    WatchSessionLimiter.heartbeatError(xhr?.status);
  }

  static heartbeatError(status_code) {
    if(status_code == 401){
      LocationAdapter.href('/');
    }

    if(status_code == 404) {
      clearInterval(heartbeatInterval);
    }
  }

  static showBanner(errorMessage, detailButtonMessage) {
    var sessionLimitBanner = document.querySelector('.session-limit-blocker');
    
    if(sessionLimitBanner) {  
      this.sendBannerImpression(sessionLimitBanner);
      sessionLimitBanner.classList.remove('hide');

      var errorDescription = document.querySelector('.b-session-limit-blocker__main-description')
      if(errorDescription) {
        errorDescription.innerText = errorMessage;
      }

      var mobileErrorDescription = document.querySelector('.b-session-limit-blocker__description')
      if(mobileErrorDescription) {
        mobileErrorDescription.innerText = errorMessage;
      }

      var limitBannerBlocker = document.querySelector('.b-session-limit-blocker__main')
      if (limitBannerBlocker) {
        limitBannerBlocker.appendChild(this.createCloseButton(this.onClickCloseButton()))
        limitBannerBlocker.appendChild(this.createButtonDetail(detailButtonMessage, 'https://support.vidio.com/support/solutions/articles/43000656968-mengapa-perangkat-saya-mencapai-batas-maksimum-'))
      }
    }
  }
  static sendBannerImpression(element) {
    if(typeof(element) != 'undefined'){
      var ahoyTracker = new AhoyTracker(element);

      window.dataLayer.push({
        event: 'impression',
        feature_name: element.dataset.gtmName,
        feature_location: element.dataset.gtmLoc,
        feature_type: element.dataset.gtmType
      });
      ahoyTracker.sendEvent();
    }
  }

  static createButtonDetail(text, href) {
    const element = document.createElement('div');

    element.className = `b-session-limit-blocker__main-button-detail`;
    element.innerHTML = `<a class="b-session-limit-blocker__main-button-detail__link">${text}</a>`;
    element.firstChild.href = href;
    
    return element;
  }

  static createCloseButton(action) {
    const element = document.createElement('button');
    element.className = `b-session-limit-blocker__close-btn`;
    element.innerHTML = `&times;`
    element.onclick = action;

    return element;
  }

  static onClickCloseButton() {
    return () => {
      let sessionLimitBanner = document.querySelector('.session-limit-blocker');
      if(sessionLimitBanner) {
        sessionLimitBanner.classList.add('hide');
      }
    }
  }
}
